import {
  getAuth,
  signInWithPhoneNumber,
  RecaptchaVerifier,
  EmailAuthProvider,
  linkWithCredential,
} from "firebase/auth";
import { collection, getDocs, query, where } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { toast } from "react-toastify";
import {
  AuthErrorMessages,
  ToastInfoMessages,
} from "../../../controllers/auth/AuthErrorMessages";
import GetEmailVerificationCode from "../../../controllers/auth/GetEmailVerificationCode";
import isUserExists from "../../../controllers/auth/isUserExists";
import PostRegister from "../../../controllers/auth/PostRegister";
import SeedBusinessRecord from "../../../controllers/auth/SeedBusinessRecord";
import SeedUserRole from "../../../controllers/auth/SeedUserRole";
import SetEmailVerified from "../../../controllers/auth/SetEmailVerified";
import { db } from "../../../firebase";
import isDuplicatedEmail from "./isDuplicatedEmail";

let UserName = "";
let Email = "";
let Business = "";

export default function useLogin() {
  let auth = getAuth();
  const [AuthState, setAuthState] = useState("email");

  const [ButtonLoader, setButtonLoader] = useState(false);
  const [Phone, setPhone] = useState("");
  const [PhoneVerification, setPhoneVerification] = useState(false);

  const [Code, setCode] = useState("");
  const [CodeSent, setCodeSent] = useState(false);
  const [Error, setError] = useState(false);
  const [PhoneError, setPhoneError] = useState(false);
  const RegisterButtonRef = useRef();

  const setup_gcaptcha = () => {
    // if (window.recaptchaVerifier !== undefined) return;
    window.recaptchaVerifier = new RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "invisible",
        callback: (response) => {
          console.log(response);
        },
      },
      auth
    );
  };
  useEffect(() => setup_gcaptcha(), []);

  const refresh_gcaptcha = () => {
    // document.getElementById("recaptcha-container").innerHTML = "";
    // window.recaptchaVerifier = undefined;
    // setup_gcaptcha();
  };

  const TerminateAuth = () => {
    // toast.error("User not found!", {
    //   position: "bottom-center",
    //   autoClose: 5000,
    //   hideProgressBar: false,
    //   closeOnClick: true,
    //   pauseOnHover: true,
    //   draggable: true,
    //   progress: undefined,
    // });
    setButtonLoader(false);
  };
  const _ResendCode = async (ph) => {
    const recaptchaVerifier = new RecaptchaVerifier(
      "reset-password-container",
      {
        size: "invisible",
        callback: async (response) => {
          // reCAPTCHA solved, allow signInWithPhoneNumber.
          console.log(response);
        },
      },
      auth
    );

    await signInWithPhoneNumber(auth, ph || Phone, recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        // setCodeSent(true);
        ToastInfoMessages("phone/code-resend-successfully");
        return true;
      })
      .catch((error) => {
        console.log(error);
        AuthErrorMessages(error.code);
        // setPhoneVerification(true);
        return true;
      });
  };
  const ResendCode = async (ph) => {
    // await refresh_gcaptcha();

    // window.recaptchaVerifier.recaptcha
    if (window.recaptchaVerifier.recaptcha !== null) {
      //   await window.recaptchaVerifier.recaptcha.reset();
      //   await window.recaptchaVerifier.recaptcha.execute();
      //   window.recaptchaVerifier.container.innerHTML = "";
      //   window.recaptchaVerifier.container.innerHTML = "";
      //   window.recaptcha = null;
      //   window.recaptchaVerifier = null;
      //   window.confirmationResult = null;
      //   await setup_gcaptcha();
      // console.log("clearing...");
      // window.recaptchaVerifier.recaptcha.reset();
      // window.recaptchaVerifier.clear();
    }

    return await signInWithPhoneNumber(
      auth,
      ph || Phone,
      window.recaptchaVerifier
    )
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        // setCodeSent(true);
        ToastInfoMessages("phone/code-resend-successfully");
        return true;
      })
      .catch(async (error) => {
        console.log(error);
        await _ResendCode(ph);
        // AuthErrorMessages(error.code);
        // setPhoneVerification(true);
        return true;
      });
  };

  const RegisterUsingPhoneNumber = async (e) => {
    return await signInWithPhoneNumber(auth, Phone, window.recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;

        setCodeSent(true);
        return true;
      })
      .catch((error) => {
        console.log(error);
        setPhoneVerification(false);
        setButtonLoader(false);
        AuthErrorMessages("auth/captcha-expired");
        return true;
      });
    // await setup_gcaptcha();
  };

  const PhoneLoginRegister = async (cred) => {
    const {
      user: { phoneNumber },
    } = cred;

    const invited = await collection(db, "invited-agents");

    const q = await query(invited, where("number", "==", phoneNumber));

    const _docs = await getDocs(q);

    let e;
    if (_docs.docs.length === 0) {
      e = {
        name: UserName,
        email: Email,
        phone: phoneNumber,
        password: "",
        business: Business,
      };
    } else {
      const { agentName, bid, aid } = await _docs.docs[0].data();
      e = {
        name: agentName,
        email: Email,
        phone: phoneNumber,
        password: "",
        business: null,
        bid,
        aid,
        role: "agent",
      };
    }

    return await PostRegister(cred, e, {
      profile: {
        ...cred.user,
      },
      providerId: "password",
      isNewUser: true,
    });
  };

  const VerifyCode = async (code) => {
    try {
      setButtonLoader(true);
      return await window.confirmationResult
        .confirm(code)
        .then(async (snapshot) => {
          if (!(await isUserExists("phone", Phone)))
            return await PhoneLoginRegister(snapshot);
          else {
            const { uid } = getAuth().currentUser;

            // Creating Business Record
            await SeedBusinessRecord(uid);
            await SeedUserRole(uid);
          }

          setButtonLoader(true);
          setError(false);
          return true;
        })
        .catch((error) => {
          AuthErrorMessages(error.code);

          console.log(error);
          setButtonLoader(false);
          setError(true);
          return false;
        });
    } catch (error) {
      console.log(error);
      setButtonLoader(false);
      AuthErrorMessages("auth/internal-error");
      return false;
    }
  };

  const PhoneAuthHandler = async () => {
    console.log("PhoneAuthHandler", Phone);

    setButtonLoader(true);

    if (Phone === "") {
      setPhoneError(true);
      setButtonLoader(false);
      return;
    } else if (await RegisterUsingPhoneNumber()) {
      setPhoneVerification(true);
      setButtonLoader(false);
    }
  };

  const CheckEmailExistence = async (data) => {
    if (!(await isUserExists("email", data))) return TerminateAuth();
  };

  const TerminateAuthEmail = () => {
    toast.error("Email does not exist", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    setButtonLoader(false);
  };

  const CheckExistenceOfEmail = async (data) => {
    try {
      if (await isDuplicatedEmail(data)) {
        TerminateAuthEmail();
        return true;
      }
    } catch (error) {
      console.log(error);
    }
  };
  const goBack = () => {
    console.log("goBack called");

    setButtonLoader(false);
    setCodeSent(false);
    setError(false);
    setPhoneVerification(false);
  };

  const verifyFromProfile = async (OTP, EmailCode, email, password) => {
    /* Email Verification */
    if ((await GetEmailVerificationCode()) * 1 === EmailCode * 1) {
      await SetEmailVerified();
    } else {
      AuthErrorMessages("auth/invalid-code");
      return "email";
    }

    /* OTP Verification */
    const credential = EmailAuthProvider.credential(email, password);
    return await window.confirmationResult
      .confirm(OTP)
      .then(async (snapshot) => {
        return await linkWithCredential(getAuth().currentUser, credential)
          .then((usercred) => {
            return true;
          })
          .catch((error) => {
            console.log(error);
            return "phone";
          });
      })
      .catch((error) => {
        return "phone";
      });
  };

  return [
    PhoneAuthHandler,
    PhoneVerification,
    setPhoneVerification,
    Phone,
    setPhone,
    AuthState,
    setAuthState,
    RegisterUsingPhoneNumber,
    RegisterButtonRef,
    CodeSent,
    setCodeSent,
    VerifyCode,
    Error,
    setError,
    Code,
    setCode,
    ButtonLoader,
    setButtonLoader,
    goBack,
    PhoneError,
    ResendCode,
    CheckEmailExistence,
    CheckExistenceOfEmail,
    verifyFromProfile,
  ];
}
